import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
class Filters {
  constructor(element) {
    this._element = element;
    this._init();
  }

  _state = {
    isOpen: false,
    scrollTop: 0,
  };

  _init() {
    this._cacheSelectors();
    this._addEventListeners();
  }

  _cacheSelectors() {
    this._content = this._element.parentNode.querySelector('.filters');
    this._close = this._content.querySelector('.filter-toggle');
    this._body = document.querySelector('body');
    this._html = document.documentElement;
  }

  _addEventListeners() {
    this._element.addEventListener('click', () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this._state.scrollTop = scrollTop;
      clearAllBodyScrollLocks();
      this._state.isOpen = !this._state.isOpen;
      this._content.setAttribute('data-open', this._state.isOpen);
      if (this._state.isOpen) {
        this._disableScroll();
      } else {
        this._enableScroll();
      }
    });
    this._close.addEventListener('click', () => {
      clearAllBodyScrollLocks();
      this._state.isOpen = false;
      this._content.setAttribute('data-open', this._state.isOpen);
      this._enableScroll();
    });
  }

  _enableScroll() {
    //this._body.scrollTop = this._html.scrollTop = this._state.scrollTop
    this._state.scrollTop = 0;
    enableBodyScroll(this._body);
    this._html.setAttribute('data-overflow', true);
  }

  _disableScroll() {
    //this._body.scrollTop = this._html.scrollTop = 0
    disableBodyScroll(this._body);
    this._html.setAttribute('data-overflow', false);
  }
}

export default Filters;
